// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.address.RentalManagerUserPropertyAddressV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyAddressV2WebApiHandler_update } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyAddressUpdateRequestDto,
  UserPropertyAddressUpdateV2ResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyAddressV2WebApiHandler_update_Args {
  postData: UserPropertyAddressUpdateRequestDto;
}

export type RentalManagerUserPropertyAddressV2WebApiHandler_update_Options = UseMutationOptions<
  UserPropertyAddressUpdateV2ResponseWebDto,
  unknown,
  RentalManagerUserPropertyAddressV2WebApiHandler_update_Args
>;

/**
 * Update address for property
 */
export const useRentalManagerUserPropertyAddressV2WebApiHandler_update = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyAddressV2WebApiHandler_update_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyAddressV2WebApiHandler_update_Args) =>
      RentalManagerUserPropertyAddressV2WebApiHandler_update(args.postData, httpClient),
  });
};
